<template>
    <el-card v-loading="!is_ok" class="page_card" ref="card">
        <el-form :inline="true" ref="selectForm" :model="selectForm" class="demo-form-inline">
            <!-- <el-form-item label="企业名称或简称">
                    <el-select style="width: 100%" v-model="selectForm.supplierId"  placeholder="请选择">
                    <el-option
                        v-for="item in supplier_list"
                        :key="item.id"
                        :label="item.displayName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="企业名称/简称">
                <el-select style="width:200px"
                    v-model="selectForm.supplierId"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    :loading="is_select"
                    @change="changeCom"
                >
                    <el-option
                    v-for="item in supplier_list"
                    :key="item.id"
                    :label="item.displayName"
                    :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="计划日期">
                <el-date-picker
                    v-model="selectForm.date"
                    type="daterange"
                    align="right"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="采购产品名称">
                <el-select v-model="selectForm.goodsId" placeholder="请选择" style="width: 100px">
                    <el-option
                        v-for="item in procuroct"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="主车">
                <el-input placeholder="请输入主车" v-model="selectForm.plateNumber"></el-input>
            </el-form-item>
             <el-form-item label="挂车">
                <el-input placeholder="请输入挂车" v-model="selectForm.carriageNumber"></el-input>
            </el-form-item>
             <el-form-item label="驾驶员">
                <el-input placeholder="请输入驾驶员" v-model="selectForm.driverName"></el-input>
            </el-form-item>
             <el-form-item label="驾驶员电话">
                <el-input placeholder="请输入驾驶员电话" v-model="selectForm.driverMobile"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button plain type="primary" :loading="is_post" @click="selectSubmit()">查询</el-button>
                <el-button plain :loading="is_post" @click="resetSelect()">重置</el-button>
                <el-button plain type="success" @click="goToAdd()" v-can="['btn:add_procurement']">+ 新增计划</el-button>
            </el-form-item>
        </el-form>
    
        <!-- 当前计划列表 -->
           <el-row v-loading="is_loading" style="margin-top: 30px;">
                    <div v-if="dataList.length == 0">
                        <div style="display: flex;align-items: center;justify-content: center;flex-direction:column;">
                            <svg-icon style="font-size: 180px" icon-class="no_order" />
                            <div style="color: #aaa">
                                暂无计划单
                            </div>
                        </div>
                    </div>
                    <template v-else>
                        <div class="tabhead" v-show='activeName=="first"'>
                            <span>采购计划数</span>
                            <span>计划采购量</span>
                            <!-- <span>实际到厂计划数</span> -->
                            <!-- <span>实际结算量</span> -->
                            <span>应付货款</span>
                            <span>实付货款</span>
                        </div>
                        <el-collapse v-model="activeNames" style=" position: relative;margin-right: 10px;">

                            <el-collapse-item v-for="(item,index) of dataList" :key="item.comID" :name="index">
                                <!-- <template slot="title">
                                    <span style="margin-left:10px;font-size: 15px;font-weight:700;overflow: hidden;">{{item.name}}</span>
                                    <div style="margin-left:50px;padding:0px 30px;border-left:1px solid #eee;">采购计划数{{item.num}}</div>
                                    <div style="margin-left:10px;padding:0px 30px;border-left:1px solid #eee;" plain>计划采购量{{item.weight}}</div>
                                    <div style="margin-left:10px;padding:0px 30px;border-left:1px solid #eee;" plain>实际到厂计划数{{item.planWeight}}</div>
                                    <div style="margin-left:10px;padding:0px 30px;border-left:1px solid #eee;" plain>实际结算量{{item.realPlanWeight}}</div>
                                    <div style="margin-left:10px;padding:0px 30px;border-left:1px solid #eee;" plain>应付货款{{item.planPrice}}</div>
                                    <div style="margin-left:10px;padding:0px 30px;border-left:1px solid #eee;" plain>实付货款(元){{item.realPlanPrice}}</div>
                                </template> -->
                               
                                <template slot="title">
                                    <span
                                        style="
                                        width: 340px;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        margin-left: 10px;
                                        font-size: 15px;
                                        font-weight: 500;
                                        "
                                        >{{ item.name }}</span
                                    >
                                    <div
                                        style="
                                        margin-left: 10px;
                                        width:110px;
                                        "
                                    >
                                    {{ item.num }}
                                    </div>
                                    <div
                                        style="
                                        margin-left: 10px;
                                        width:110px;
                                        "
                                    >
                                    {{ item.weight }}
                                    </div>
                                    <!-- <div
                                        style="
                                        margin-left: 10px;
                                        width:110px;
                                        "
                                    >
                                    {{item.planWeight}}
                                    </div> -->
                                    <!-- <div
                                        style="
                                        margin-left: 10px;
                                        width:110px;
                                        "
                                    >
                                        {{ item.realPlanWeight }}
                                    </div> -->
                                    <div
                                        style="
                                        margin-left: 10px;
                                        width:110px;
                                        "
                                    >
                                    {{ item.planPrice }}
                                    </div>
                                    <div
                                        style="
                                        margin-left: 10px;
                                        width:110px;
                                        "
                                    >
                                        {{ item.paidInPayment }}
                                    </div>
                                </template>
                                <div class="content_table">
                                    <el-table
                                        v-loading="is_loading"
                                        style="width: 100%;"
                                        :data="item.orders"
                                        :row-class-name="tableRowClassName"
                                        :header-cell-style='{background:"#1890ff",color:"#fff"}'
                                    >
                                        <el-table-column
                                        label="序号"
                                        type="index"
                                        align="center"
                                        min-width="3%"
                                        width="55"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="goodsName"
                                        label="产品"
                                        align="center"
                                        min-width="7%"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="planDate"
                                        label="计划日期"
                                        align="center"
                                        min-width="9%"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="planWeight"
                                        align="center"
                                        label="计划吨数"
                                        min-width="7%"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="letterPrice"
                                        label="产品单价"
                                        align="center"
                                        min-width="7%"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="planAmount"
                                        label="总价"
                                        align="center"
                                        min-width="8%"
                                        >
                                        </el-table-column>
                                        <!-- <el-table-column
                                        prop="purchaseType"
                                        label="计划类型"
                                        align="center"
                                        min-width="7%"
                                        >
                                        <template slot-scope="scope">
                                            <div
                                            class="primary_text"
                                            v-if="scope.row.purchaseType == 0"
                                            >
                                            本厂计划
                                            </div>
                                            <div
                                            class="warning_text"
                                            v-else-if="scope.row.purchaseType == 1"
                                            >
                                            采购计划
                                            </div>
                                            <div
                                            class="warning_text"
                                            v-else-if="scope.row.purchaseType == 2"
                                            >
                                            临时计划
                                            </div>
                                            <div
                                            class="warning_text"
                                            v-else-if="scope.row.purchaseType == 10"
                                            >
                                            其他计划
                                            </div>
                                        </template>
                                        </el-table-column> -->
                                        <el-table-column
                                        prop="plateNumber"
                                        label="主车号"
                                        align="center"
                                        min-width="8%"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="carriageNumber"
                                        label="挂车号"
                                        align="center"
                                        min-width="8%"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="driverName"
                                        label="驾驶员"
                                        align="center"
                                        min-width="8%"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="driverMobile"
                                        label="驾驶员电话"
                                        align="center"
                                        min-width="10%"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="remark"
                                        label="备注"
                                        align="center"
                                        min-width="8%"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        label="操作"
                                        align="center"
                                        min-width="19%"
                                        >
                                        <template slot-scope="scope">
                                            <div class="btn-box">
                                                <el-button
                                                    size="mini"
                                                    type="info"
                                                    class="btnBh"
                                                    style="padding:5px;margin-bottom: 5px;"
                                                    v-if="has_permission('view:plan_detail')"
                                                    :disabled="is_post"
                                                    @click="goToDetail(scope.row,'detail')"
                                                    plain
                                                    >计划单详情</el-button
                                                >
                                                <el-button
                                                    size="mini"
                                                    type="info"
                                                    class="btnBh"
                                                    v-can="['btn:purchase_modification_information']"
                                                    style="padding:5px;margin-bottom: 5px;"
                                                    :disabled="is_post"
                                                    @click="goToDetail(scope.row, 'edit')"
                                                    plain
                                                    >修改基本信息</el-button
                                                >
                                            </div>
                                        </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <!-- <el-card :class="checked.includes(item.id)?'order_item active':'order_item'" shadow="hover" v-for="(d,i) in item.orders" :key='i'>
                                    <div class="item_body">
                                        <el-row class="item_header">
                                            <div class="btns">
                                                <el-tooltip effect="light" content="计划单详情" placement="top-start" v-if="has_permission('view:plan_detail')">
                                                <span style="display: inline-block" @click.stop="goToDetail(d,'detail')">
                                                    <el-avatar size="large" shape="circle" class="item_btn" @click="goToAdd"><svg-icon icon-class="component" /></el-avatar>
                                                </span>
                                                </el-tooltip>
                                                <el-tooltip effect="light" content="修改基本信息" placement="top-start" >
                                                <span style="display: inline-block" @click.stop="goToDetail(d,'edit')">
                                                    <el-avatar size="large" shape="circle" class="item_btn"><svg-icon icon-class="edit" /></el-avatar>
                                                </span>
                                                </el-tooltip> -->
                                                <!-- <el-tooltip effect="light" content="一键复制" placement="top-start" >
                                                    <span style="display: inline-block" @click.stop="goToCopy(d,'copy')">
                                                        <el-avatar size="large" shape="circle" class="item_btn" @click="goToAdd"><svg-icon icon-class="component" /></el-avatar>
                                                    </span>
                                                </el-tooltip> -->
                                                <!-- <el-tooltip effect="light" content="调价" placement="top-start" v-if="d.status < 10 && has_permission('btn:change_price')">
                                                    <span style="display: inline-block" @click.stop="editPrice(d)">
                                                        <el-avatar size="large" shape="circle" class="item_btn"><svg-icon icon-class="price" /></el-avatar>
                                                    </span>
                                                </el-tooltip> -->

                                                <!-- <el-tooltip effect="light" content="补录磅单" placement="top-start" v-if="d.purchaseType == 1 && has_permission('btn:add_pound')">
                                                <span style="display: inline-block" @click.stop="goToDetail(d.id,'weight')">
                                                    <el-avatar size="large" shape="circle" class="item_btn"><svg-icon icon-class="form" /></el-avatar>
                                                </span>
                                                </el-tooltip> -->

                                                <!--v-if="item.orderType == 0 && (item.status == 21 || item.status == 26) && has_permission('api:weighing')"-->
                                                <!-- <el-tooltip effect="light" content="模拟称重" placement="top-start" v-if="d.purchaseType == 0 && (d.status == 21 || d.status == 26) && has_permission('api:weighing')">
                                                    <span style="display: inline-block" @click.stop="setWeight(d)">
                                                        <el-avatar size="large" shape="circle" class="item_btn"><svg-icon icon-class="tank" /></el-avatar>
                                                    </span>
                                                </el-tooltip>

                                                <el-tooltip effect="light" content="模拟铅封" placement="top-start" v-if="d.purchaseType == 0 &&  d.status == 27 && has_permission('api:weighing')">
                                                    <span style="display: inline-block" @click.stop="setLead(d)">
                                                        <el-avatar size="large" shape="circle" class="item_btn"><svg-icon icon-class="lock" /></el-avatar>
                                                    </span>
                                                </el-tooltip> -->
                                            <!-- </div>
                                        </el-row>
                                        <el-row style="width: 100%;margin: 25px 20px 10px 20px">
                                            <div class="item_item ptext">
                                                序号: {{i+1}}
                                            </div>
                                            <div class="item_item ptext">
                                                产品: {{d.goodsName}}
                                            </div>
                                            <div class="item_item ptext">
                                                计划日期: {{d.planDate}}
                                            </div>
                                            <div class="item_item ptext">
                                                计划吨数: {{d.planDate}}
                                            </div>
                                            <div class="item_item ptext">
                                                计划类型:
                                                <span class="primary_text" v-if="d.purchaseType == 0">本厂计划</span>
                                                <span class="warning_text" v-if="d.purchaseType == 1">采购计划</span>
                                                <span class="primary_text" v-if="d.purchaseType == 2">临时计划</span>
                                                <span class="warning_text" v-if="d.purchaseType == 10">其他计划</span>
                                            </div>
                                             <div class="item_item ptext">
                                                主车号: {{d.plateNumber}}
                                            </div>
                                            <div class="item_item ptext">
                                                车挂: {{d.carriageNumber}}
                                            </div>
                                            <div class="item_item ptext">
                                                驾驶员: {{d.driverName}}
                                            </div>
                                            <div class="item_item ptext">
                                                联系电话: {{d.driverMobile}}
                                            </div>
                                           
                                        <div class="item_item ptext">
                                                备注: {{d.remark}}
                                            </div> -->
                                        
                                            <!-- <div class="item_item ptext">
                                                提货方式:
                                                <span class="primary_text" v-if="d.deliverType == 0">自提</span>
                                                <span class="warning_text" v-if="d.deliverType == 1">配送</span>
                                            </div>
                                            <div class="item_item ptext">
                                                临时优惠: ￥ <span class="warning_text">{{d.temCut}}</span>
                                            </div>
                                            <div class="item_item ptext">
                                                销售优惠: ￥ <span class="warning_text">{{d.saleCut}}</span>
                                            </div>
                                            <div class="item_item ptext">
                                                计划装液量: <span class="success_text">{{d.planWeight}} 吨</span>
                                            </div>
                                            <div class="item_item ptext">
                                                执行价格: <span class="danger_text">￥ {{d.realPrice}} 元/吨</span>
                                            </div>
                                            <div class="item_item ptext">
                                                下单时间: {{d.addTime}}
                                            </div> -->
                                        <!-- </el-row>
                                    </div>
                                    <div class="item_footer">
                                        <div style="float: left"> -->
                                            <!-- <span class="ptext">计划编号:</span>
                                            <el-link :underline="false" type="primary" @click="goToDetail(d.id)">{{d.orderSn}}</el-link>
                                            <el-tag style="margin-left: 10px" :type="statusType(d.status)">{{parseStatus(d.status)}}</el-tag> -->
                                        <!-- </div>
                                        <div style="float: right">
                                            <span class="ptext">总价: <span class="info_text" style="font-size: 18px">￥ {{d.planAmount}} 元</span></span>
                                        </div>
                                    </div>
                                </el-card> -->
                            </el-collapse-item>
                        </el-collapse>
                    </template>

                </el-row>
        <!-- 新增计划 -->
        <el-dialog :title="id==0?'添加采购计划':'修改采购计划'" :visible.sync="isAdd" width="30%" @close="close">
            <div v-if='id==0' class="view_section_right_view" @click="onButtonClick">
                智能识别
            </div>
            <el-form label-position="right" :model="addForm" ref="addForm" :rules="Rules" label-width="120px" >
                <el-form-item label="供应商" prop="supplierId">
                     <!-- <el-select style="width: 100%" 
                        :multiple="false"
                        filterable
                        remote
                        reserve-keyword
                        v-model="addForm.supplierId"  
                        placeholder="请选择供应商企业名称">
                        <el-option
                            v-for="item in supplier_list"
                            :key="item.id"
                            :label="item.displayName"
                            :value="item.id">
                        </el-option>
                    </el-select> -->
                    <el-select  style="width: 100%" 
                        v-model="addForm.supplierId"
                        clearable
                        filterable
                        placeholder="请选择或输入供应商企业名称"
                        class="product-input"
                        allow-create
                    >
                       <el-option
                            v-for="item in supplier_list"
                            :key="item.id"
                            :label="item.displayName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="计划日期" prop="date">
                    <el-select v-model="addForm.date" placeholder="请选择采购日期" style="width:100%">
                        <el-option
                            v-for="(item,index) in dates"
                            :key="index"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物资" prop="goodsId">
                    <el-select v-model="addForm.goodsId" placeholder="请选择采购产品名称"  :disabled=disabledData style="width:100%">
                        <el-option
                            v-for="item in procuroct"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="主车号" prop="plateNumber">
                    <el-input placeholder="请输入采购主车号: 宁A12346" @input="plateNumberInput" show-word-limit :disabled=disabledData maxlength="7" v-model="addForm.plateNumber"></el-input>
                </el-form-item>
                <el-form-item label="挂车号" prop="carriageNumber">
                    <el-input placeholder="请输入采购挂车号: 宁A1234挂" @input="carriageNumberInput" show-word-limit  :disabled=disabledData maxlength="7" v-model="addForm.carriageNumber"></el-input>
                </el-form-item>
                <el-form-item label="驾驶员" prop="driverName">
                    <el-input placeholder="请输入驾驶员" maxlength="10" show-word-limit  :disabled=disabledData v-model="addForm.driverName"></el-input>
                </el-form-item>
                <el-form-item label="驾驶员电话" prop="driverMobile">
                    <el-input placeholder="请输入驾驶员电话" maxlength="11" show-word-limit :disabled=disabledData v-model="addForm.driverMobile"></el-input>
                </el-form-item>
                <el-form-item label="采购单价" prop="unitPrice">
                    <el-input placeholder="请输入采购单价"   :disabled=disabledData v-model="addForm.unitPrice"></el-input>
                </el-form-item>
                <el-form-item label="采购吨数" prop="weight">
                    <el-input placeholder="请输入采购吨数"  :disabled=disabledData v-model="addForm.weight"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                     <el-input v-model="addForm.remark"  :disabled=disabledData type="textarea" maxlength="100" :autosize="{ minRows: 4, maxRows: 8}" placeholder="备注" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button plain type="primary" :loading="is_post" @click="addSubmit()">提 交</el-button>
                    <el-button plain :loading="is_post" @click="resetAdd()">重 置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        
        <el-dialog title="智能识别" :visible.sync="is_smart" width="35%" @close='handleCancle'>
            <div class="box">
                <div class="box-title">
                    <span>智能输入短信信息</span>
                </div>
                <div>
                    <el-input v-model="inputVal" @input="smartInput" @change="btnInput" class="textarea-box" :autosize="{ minRows: 6, maxRows: 12}" placeholder-class="remark-box" type="textarea" maxlength="50000"  placeholder="请输入需要识别的内容，每条信息之间用#号隔开，例：车牌号：XXXXXX 车挂号：XXXXXX挂 司机:XXX 手机号：1XXXXXXXXXXX 押运员:XXX 手机号:1XXXXXXXXXXX"></el-input>
                </div>
                <div class="btn-box">
                    <div @click="resetBtn" class="btn-common btn-reset">清空</div>
                    <div @click="btnClick" class="btn-common btn-identify">识别</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="智能识别列表" :visible.sync="is_smart_list" width="35%" @close='handleCancleList'>
            <div v-for="item in orderList" :key="item.id"  class="order-list">
                <div @click="btnClickList(item.orderData)" class="order-text">{{item.name}}</div>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import request from '@/utils/request'
import can from "@/directive/can/index.js"
import {parseTime,deepClone} from '@/utils'
import {mapGetters} from 'vuex'
import {stringTrim} from '@/utils/elvalid'


export default {
    name: 'customer_company',
    directives:{can},
    computed:{
        ...mapGetters([
            'permissions'
        ])
    },
    data() {
        return {
            is_smart:false,
            inputVal:'',
            newInputList:[],
            is_smart_list:false,
            orderList:[],
            orderListDetail:[],
            remark_dialog:false,
            active_item:null,
            is_ok: false,
            is_post: false,
            data: [],
            showtable: false,
            tableMaxHeight: 0,
            is_loading:false,
            procuroct:[],//产品列表
            supplier_list:[],//供货公司
            dates:[],//计划日期
            id:0,
            disabledData:false,
            isAdd:false,
            dataList:[],
            activeNames:[],
            activeName: "first",
            checked:[],
            is_select:false,
            Rules:{
                supplierId:[
                    {required:true,message:'请选择供应商',trigger:'blur'}
                ],
                goodsId:[
                    {required:true,message:'请选择采购产品名称',trigger:'blur'}
                ],
                 carriageNumber:[
                    {required: true, message: '请输入挂车号', trigger: 'blur'},
                    {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dA-Z]{4}挂$/,message:"请输入正确的挂车号",trigger: 'blur'}
                ],
                date:[
                    {required: true, message: '请选择日期', trigger: 'blur'},
                ],
                driverMobile:[
                    {required: true, message: '请输入驾驶员电话', trigger: 'blur'},
                    {pattern:/^1[345789]\d{9}$/,message:"请输入正确的驾驶员电话",trigger: 'blur'}
                ],
                driverName:[
                    {required: true, message: '请输入驾驶员', trigger: 'blur'},
                    { validator: stringTrim, trigger: 'blur' }
                ],
                plateNumber:[
                    {required: true, message: '请输入主车号', trigger: 'blur'},
                    {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dABCDEFGHJKLNMxPQRSTUVWXYZ]{5}$/,message:"请输入正确的主车号",trigger: 'blur'}
                ],
                // unitPrice:[
                //     {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个数字,最多保留2位小数",trigger: 'blur'}
                // ],
                // weight:[
                //     {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个数字,最多保留2位小数",trigger: 'blur'}
                // ],
            },
            selectForm: {
                supplierId:'',
                driverMobile:'',
                driverName:'',
                unitPrice:'',
                carriageNumber:'',
                goodsId:'',
                plateNumber:'',
            },
            addForm:{
               supplierId:'',
               driverMobile:'',
               driverName:'',
               unitPrice:0,
               carriageNumber:'',
               goodsId:'',
               plateNumber:'',
               weight:0,
               remark:''
            },
            sales_users:'',
           total:0,
            //计划日期
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            
        }
    },
    methods: {
        changeCom(e){
            this.selectForm.supplierId=e;
            this.getData();
        },
        onButtonClick() {
            this.is_smart=true;
        },
        handleCancle () {
            this.is_smart = false;
            this.inputVal='';
        },
        handleCancleList () {
            this.is_smart_list = false;
            this.orderList=[];
        },
        btnInput(e) {
            // this.inputVal=e;
        },
        smartInput(e){
            this.inputVal = e.toUpperCase()
        },
        resetBtn() {
            this.inputVal='';
        },
        plateNumberInput(e){
            this.addForm.plateNumber = e.toUpperCase();
        },
        carriageNumberInput(e){
            this.addForm.carriageNumber = e.toUpperCase();
        },
        //将汉字与英文、数字、下划线之间添加一个空格
        insert_spacing(str) {
            var p1=/([1])([\u4e00-\u9fa5]+)/gi;
            var p2=/([\u4e00-\u9fa5]+)([1])/gi;
            return str.replace(p1, "$1 $2").replace(p2, "$1 $2")
        },
        btnClick: function () {
            if(this.inputVal==''){
                this.$message.warning("识别内容不能为空！");
                return;
            }
            if(this.inputVal.indexOf("#") != -1){
            var inputList = this.inputVal.replace(/^(\s|#)+|(\s|#)+$/g, '').split("#");
            if(inputList.length<=1){
                this.getSingleData();
            }else{
                for(var i = 0; i < inputList.length; i++){
                var index;
                if(inputList[i].indexOf("：") != -1){
                    index = inputList[i].indexOf("：");
                }else if(inputList[i].indexOf("、") != -1){
                    index = inputList[i].indexOf("、");
                }
                var result = inputList[i].substr(index + 1,inputList[i].length);
        
                while(result.indexOf('-') != -1){
                    result=result.replace('-', ' ');
                }
                while(result.indexOf('司机:') != -1){
                    result=result.replace('司机:', ' ');
                }
                while(result.indexOf('司机') != -1){
                    result=result.replace('司机', ' ');
                }
                while(result.indexOf('押运员:') != -1){
                    result=result.replace('押运员:', ' ');
                }
                while(result.indexOf('电话') != -1){
                    result=result.replace('电话', ' ');
                }
                while(result.indexOf('手机号:') != -1){
                    result=result.replace('手机号:', ' ');
                }
                while(result.indexOf('手机号') != -1){
                    result=result.replace('手机号', ' ');
                }
                while(result.indexOf('身份证号码') != -1){
                    result=result.replace('身份证号码', ' ');
                }
                while(result.indexOf('身份证') != -1){
                    result=result.replace('身份证', ' ');
                }
                // 将汉字和数字中间添加空格
                inputList[i]=this.insert_spacing(result);
                var resultList=inputList[i].trim().split(/\s+/);
                inputList[i]=resultList;
                }
            }
            // 转换展示的新数组
            var newLists = [];
            inputList.forEach((el, index) => {
                var obj = {
                name: "订单"+(index + 1),
                orderData: el,
                };
                newLists.push(obj);
            });
            this.newInputList=newLists;
            
            //展示订单列表
            this.is_smart_list=true;
            this.orderList=this.newInputList
            
            }else{
                this.getSingleData();
            }
        },
        getSingleData:function(){
            var index;
            if(this.inputVal.indexOf("：") != -1){
             index = this.inputVal.indexOf("：");
            }else if(this.inputVal.indexOf("、") != -1){
             index = this.inputVal.indexOf("、");
            }
            var result = this.inputVal.substr(index + 1,this.inputVal.length);

            while(result.indexOf('-') != -1){
             result=result.replace('-', ' ');
            }
            while(result.indexOf('司机:') != -1){
             result=result.replace('司机:', ' ');
            }
            while(result.indexOf('司机') != -1){
             result=result.replace('司机', ' ');
            }
            while(result.indexOf('押运员:') != -1){
             result=result.replace('押运员:', ' ');
            }
            while(result.indexOf('电话') != -1){
             result=result.replace('电话', ' ');
            }
            while(result.indexOf('手机号:') != -1){
             result=result.replace('手机号:', ' ');
            }
            while(result.indexOf('手机号') != -1){
             result=result.replace('手机号', ' ');
            }
            while(result.indexOf('身份证号码') != -1){
             result=result.replace('身份证号码', ' ');
            }
            while(result.indexOf('身份证') != -1){
             result=result.replace('身份证', ' ');
            }
            // 将汉字和数字中间添加空格
            var lists=this.insert_spacing(result).trim().split(/\s+/);
            this.orderListDetail=lists;
            //关闭智能识别窗口
            this.is_smart=false;
            this.getInfoDetails();
        },
        getInfoDetails(){
            var countName=0;
            var countPhone=0;
            var countIdCard=0;
            for(let item of this.orderListDetail){   
            //车牌号验证
            if (/(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9]{1}$)/.test(item)) {
                this.addForm.plateNumber=item;
            }
            if (/(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[挂]{1}$)/.test(item)) {
                this.addForm.carriageNumber=item;
            }
            //姓名验证
            if (/^[\u4E00-\u9FA5A-Za-z]+$/.test(item)) {
                if(item.length<=6){
                    countName+=1;
                    if(countName==1){
                        this.addForm.driverName=item;
                    }else{
                        this.addForm.escortName=item;
                    }
                }
            }
            //手机号码验证：
            if (/^((13[0-9])|(14[0-9])|(15[0-9])|(17[0-9])|(18[0-9]))\d{8}$/.test(item)) {
                countPhone+=1;
                if(countPhone==1){
                 this.addForm.driverMobile=item;
                }else{
                  this.addForm.escortMobile=item;
                }
            }
            //身份证验证：
            if (/(\d{15}$)|(\d{18}$)|(^\d{17}(\d|X|x)$)/.test(item)) {
                countIdCard+=1;
                
                }
            }
        },
        btnClickList(e){
            //关闭智能识别窗口
            this.is_smart_list=false;
            this.is_smart=false;
            this.orderListDetail=e;
            this.getInfoDetails();
        },
        clickDrop(e, item) {
            if(e == "edit"){
                this.$router.push({name:"edit_company",params:{id:item.id}});
            }else if(e == "money"){
                this.$router.push({name:"financial_list",query:{id:item.id}});
            }else if(e == "del"){
                this.is_post = true;
                request.post("company/change_status",{id:item.id,status:0}).then(res=>{
                    this.$message.success("操作成功");
                    item.status = 0;
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            }else if(e == "redel"){
                this.is_post = true;
                request.post("company/change_status",{id:item.id,status:1}).then(res=>{
                    this.$message.success("操作成功");
                    item.status = 1;
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            }
        },
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData(false);
        },
        loadAddress() {
            if (window.pandc) {
                this.address = pandc
                return false
            }
            let el = document.createElement('script')
            el.src = '/address.js'
            el.onload = () => {
                this.address = window.pandc
            }
            document.getElementsByTagName('head')[0].appendChild(el)
        },
        selectSubmit() {
            this.getData(false);
        },
        resetSelect(){
            this.selectForm= {
                supplierId:'',
                driverMobile:'',
                driverName:'',
                unitPrice:'',
                carriageNumber:'',
                goodsId:'',
                plateNumber:'',
            };
            this.$refs["selectForm"].resetFields();
            this.getData(false);
        },
        goToAdd() {
            this.isAdd=true;
        },
        getData(is_init = false){
            if(!is_init){
                this.is_loading = true;
                this.is_post = true;
            }
            request.post("order/purchase/list",this.selectForm).then(res=>{
                if(res.code==200){
                    this.dataList=res.data
                }
                if(!is_init){
                    this.is_post = false;
                    this.is_loading = false;
                }else{
                    this.is_ok = true;
                }
            }).catch(err=>{
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                this.showtable = true
                if(!is_init){
                    this.is_post = false;
                    this.is_loading = false;
                }else{
                    this.is_ok = true;
                }
            });
        },
        // 把每一行的索引放进row
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
            
        },
        getSalers(){
            return new Promise((resolve, reject)=>{
                request.get("company/sellers_option").then(res=>{
                    this.sales_users = this.sales_users.concat(res.data);
                    resolve();
                }).catch(err=>{
                    reject(err);
                });
            });
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
        get_saler_name(item){
            let res = "";
            for(let user of this.sales_users){
                if(item.uid == user.id){
                    res = user.displayName;
                    break;
                }
            }
            return res;
        },
        getProvince(item){
            let arr = [];
            for(let p of this.address){
                if(p.value == item.province){
                    arr.push(p.label);
                    for(let city of p.children){
                        if(city.value == item.city){
                            arr.push(city.label);
                            for(let co of city.children){
                                if(co.value == item.county){
                                    arr.push(co.label);
                                    break;
                                }
                            }
                            break;
                        }
                    }
                    break;
                }
            }
            return arr.length > 0?arr.join(" "):"";
        },
        showRemark(item){
            this.active_item = item;
            this.remark_dialog = true;
        },
         statusType(n){
            if(n < 10){
                return "warning";
            }else if(n >= 10 && n < 20){
                return "primary";
            }else if(n >= 20 && n <30){
                return "success";
            }
        },
        //手风琴效果
        handleChange(val){
            this.activeNames=val;
        },

        //获取产品列表
        procuremData(){
            request.get("material/dropdown").then(res=>{
                this.procuroct = res.data;
            }).catch(err=>{

            });
        },
        //供货公司
        get_supplier_list(){
            request.post("company/logistics_supplier_option",{type:1,keyword:""}).then(res=>{
                this.supplier_list = res.data;
            }).catch(err=>{
                console.log(err);
            });
        },
        //新建
        addSubmit(){
            if(this.id==0){
                 this.$refs["addForm"].validate(valid=>{
                    if(!valid) return false;
                    this.is_post = true;
                    request.post('order/purchase/create',this.addForm).then(res=>{
                        if(res.code==200){
                            this.isAdd=false;
                            this.is_post=false
                            this.$refs["addForm"].resetFields();
                            this.getData();
                        }
                    
                    }).catch(err=>{
                        this.is_post=false
                        console.log('新增采购计划失败')
                    })
                })
            }else{
                this.$refs["addForm"].validate(valid=>{
                    if(!valid) return false;
                    this.is_post = true;
                   
                    request.post('order/purchase/edit',this.addForm).then(res=>{
                        if(res.code==200){
                            this.isAdd=false;
                            this.is_post=false;
                             this.id=0;
                             this.addForm={
                                supplierId:'',
                                driverMobile:'',
                                driverName:'',
                                unitPrice:'',
                                carriageNumber:'',
                                goodsId:'',
                                plateNumber:'',
                                weight:'',
                                remark:''
                            }
                            this.$refs["addForm"].resetFields();
                            this.disabledData=false;
                            this.getData();
                        }
                    
                    }).catch(err=>{
                        this.is_post=false
                        console.log('修改采购计划失败')
                    })
                })
            }
            
        },
        //重置
        resetAdd(){
            this.$refs["addForm"].resetFields();
            this.addForm={
                supplierId:'',
                driverMobile:'',
                driverName:'',
                unitPrice:'',
                carriageNumber:'',
                goodsId:'',
                plateNumber:'',
                weight:'',
                remark:''
            }
        },
        //修改采购计划
        goToDetail(item,type){
            if(type=='edit'){
                this.isAdd=true;
                this.id=item.id;
                this.addForm.orderId=item.id;
                this.addForm.supplierId=item.supplierId;
                this.addForm.driverMobile=item.driverMobile;
                this.addForm.date=item.planDate;
                this.addForm.driverName=item.driverName;
                this.addForm.unitPrice=item.realPrice;
                this.addForm.carriageNumber=item.carriageNumber;
                this.addForm.goodsId=item.goodsId;
                this.addForm.weight=item.planWeight;
                this.addForm.plateNumber=item.plateNumber;
                this.addForm.remark=item.remark;
            }else{
                let id=item.id;
                this.$router.push({name:"financial_detail",params:{id}});
            }
           
        },
        goToCopy(item,type){
            if(type=='copy'){
                this.disabledData=true;
                this.addForm.supplierId=item.supplierId;
                this.addForm.driverMobile=item.driverMobile;
                this.addForm.date=item.planDate;
                this.addForm.driverName=item.driverName;
                this.addForm.unitPrice=item.realPrice;
                this.addForm.carriageNumber=item.carriageNumber;
                this.addForm.goodsId=item.goodsId;
                this.addForm.weight=item.planWeight;
                this.addForm.plateNumber=item.plateNumber;
                this.addForm.remark=item.remark;
            }
        },
        close(){
            this.id=0;
            this.addForm={
                supplierId:'',
                driverMobile:'',
                driverName:'',
                unitPrice:'',
                carriageNumber:'',
                goodsId:'',
                plateNumber:'',
                weight:'',
                remark:''
            }
            this.disabledData=false;
        }


    },
    async created() {
        await this.getSalers();

        //获取产品列表
        this.procuremData();
        //计划日期
        let time = new Date();
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));
        time = time.getTime()+86400000;
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));
    },
    mounted() {
        //获取所有地址信息
        this.loadAddress()
        this.getData(true);
        //供货公司
        this.get_supplier_list();
    }
}
</script>

<style scoped lang="scss">
.order_item{
    margin-bottom: 20px;
    margin-right: 10px;

    &.active{
        background: rgb(217, 236, 255);
    }

    .item_body{
        min-height: 110px;
        padding: 20px;
        position: relative;

        .item_header{
            height: 20px;
            display: flex;
            align-items: center;
            line-height: 20px;
            width: 100%;

            .btns{
                position: absolute;
                top: -10px;
                right: -10px;

                .item_btn{
                    margin-left: 10px;
                    transition: all 0.5s;
                    cursor: pointer;
                    color: #67C23A;
                    background: transparent;
                    &:hover{
                        color: #fff;
                        background:#67C23A;
                        font-size: 1.1em;
                    }
                }
            }
        }

        .item_item{
            display: inline-block;
            margin-right: 30px;
            line-height: 30px;
            &.ptext{
                font-size: 16px;
            }
        }

    }

    .item_footer{
        height: 39px;
        border-top: 1px solid #ddd;
        line-height: 39px;
        font-size: 14px;
        padding: 0 20px;
    }

    .ptext{
        color: #666666;
        font-size: 14px;
    }
}
    .view_section_right_view {
        padding: 9px 0px;
        background: #1890ff;
        border-radius: 8px;
        margin-left: 78%;
        margin-bottom: 3%;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: flex;
        justify-content: center;
        font-weight: 400;
        color: #ffffff;
        width: 90px;
    }
    .flex{
        display: flex;
        justify-content: space-between;
    }
    .box{
        padding: 5%;
    }
    .textarea-box{
        width: 90%;
    }
    .remark-box{
        color: #9a9898
    }
    .btn-box{
        display: flex;
        justify-content: space-around;
        font-size: 18px;
    }
    .btn-common{
        width: 35%;
        padding: 10px;
        border-radius: 10px;
        text-align: center;
        margin-top: 15%;
    }
    .btn-reset{
        background:#DCDCDC;
    }
    .btn-identify{
        background:#658bef;
        color: #ffffff;
    }
    .box-title{
        font-size: 18px;
        margin-bottom: 3%;
    }
    .order-list{
        padding: 2%;
        margin: 2%;
        border-bottom: 2px solid #DCDCDC;
    }
    .order-text{
        padding: 12px 0;
        font-size: 16px;
        color: #696969;
    }
    .tabhead{
        position: absolute;
        top: -28px;
        left: 274px;
        z-index: 999;
    }
    .tabhead span{
    font-size:13px;
    margin-left:50px;
    }
</style>
